import { AppointmentProposalOption } from '../../../data-access/appointmentProposalOptions';

export const getSelectedOptionNames = (
  options: AppointmentProposalOption[],
  selectedOptionIds: string[]
): string[] =>
  options
    .filter((option) =>
      selectedOptionIds.includes(option.appointmentProposalOptionId || '')
    )
    .map((option) => option.name);
